var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59062 15.5844C3.59062 8.96043 8.96043 3.59062 15.5844 3.59062H44.4156C51.0396 3.59062 56.4094 8.96043 56.4094 15.5844V44.4156C56.4094 51.0396 51.0396 56.4094 44.4156 56.4094H15.5844C8.96043 56.4094 3.59062 51.0396 3.59062 44.4156V15.5844Z",
    fill: "white",
    stroke: "#CE838F",
    strokeWidth: 7.18125
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.19961,
    height: 23.7652,
    rx: 3.09981,
    transform: "matrix(0.620682 -0.784062 0.620682 0.784062 10.0519 29.207)",
    fill: "#CE838F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.19961,
    height: 39.1639,
    rx: 3.09981,
    transform: "matrix(0.620682 0.784062 -0.620682 0.784062 45.4734 12.3715)",
    fill: "#CE838F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.03d48105aabc850983c28f6553a9a09f.svg";
export { ForwardRef as ReactComponent };